module.exports = __webpack_public_path__ + "img/qadiri.690a6600.png";